/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.buildTypeOperators = void 0;

var _filterTypes = _interopRequireDefault(require("./filterTypes"));

var buildTypeOperators = function buildTypeOperators(filterTypes) {
  return Object.keys(filterTypes).reduce(function (acc, filterTypeName) {
    var filterType = filterTypes[filterTypeName];

    if (!filterType || !filterType.operators) {
      return acc;
    }

    var operators = filterType.operators.reduce(function (operatorAccumulator, operator) {
      operatorAccumulator[operator.name] = operator;
      return operatorAccumulator;
    }, {});
    acc[filterTypeName] = operators;
    return acc;
  }, {});
};

exports.buildTypeOperators = buildTypeOperators;

var _default = function _default(data, filterValueArray) {
  var filterTypes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _filterTypes.default;
  var columnsMap = arguments.length > 3 ? arguments[3] : undefined;
  var typeOperators = buildTypeOperators(filterTypes);

  var filterFn = function filterFn(item, index, data) {
    var filterParam = {};

    for (var i = 0, len = filterValueArray.length; i < len; i++) {
      var fv = filterValueArray[i];
      var name = fv.name,
          getFilterValue = fv.getFilterValue,
          filterValue = fv.value,
          type = fv.type,
          operator = fv.operator,
          active = fv.active,
          fn = fv.fn;

      if (active === false) {
        continue;
      }

      if (!filterTypes[type]) {
        continue;
      }

      filterParam.emptyValue = fv.hasOwnProperty('emptyValue') ? fv.emptyValue : filterTypes[type].emptyValue;
      filterParam.filterValue = filterValue;

      if (columnsMap) {
        filterParam.column = columnsMap[name];
      }

      var currentTypeOperators = typeOperators[type];

      if (!fn && !currentTypeOperators) {
        console.error("No filter of type \"".concat(type, "\" found!"));
        continue;
      }

      if (!fn && !currentTypeOperators[operator]) {
        console.error("No operator \"".concat(operator, "\" found for filter type \"").concat(type, "\"!"));
        continue;
      }

      if (filterParam.filterValue === filterParam.emptyValue && !currentTypeOperators[operator].filterOnEmptyValue) {
        continue;
      }

      var _filterFn = fn || currentTypeOperators[operator].fn;

      filterParam.data = item;
      filterParam.value = typeof getFilterValue == 'function' ? getFilterValue({
        data: item,
        value: item[name]
      }) : item[name];

      if (_filterFn(filterParam) !== true) {
        return false;
      }
    }

    return true;
  };

  if (data === undefined) {
    return filterFn;
  }

  return data.filter(filterFn);
};

exports.default = _default;